export default "__VITE_ASSET__BShg9PSn__"